import { Box, ToggleButtonGroup, ToggleButton, Button } from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";
import { styles } from "./Styles";
import CustomDatePicker from "./CustomDatePicker";

const actionGroup = ({
  value,
  name,
  onChange,
  toggleOptions = [
    { label: "Custom", value: "custom" },
    { label: "3M", value: "3" },
    { label: "6M", value: "6" },
    { label: "Default", value: "12" },
  ],
  onDownload,
  excelOption,
  onClose,
  isActiveTab,
  openDatePicker,
  setOpenDatePicker,
  openCSVWindow,
  setOpenCSVWindow,
  downloadAsCSV,
  disabled,
  setMonth,
}: any) => {
  const isActive = isActiveTab?.name === name;
  const activeValue = isActive ? isActiveTab?.value : value;
  const serverCSVDownload = () => setOpenCSVWindow(true)

  return (
    <div style={{ position: "relative" }}>
      <Box
        display="flex"
        alignItems="center"
        gap={0}
        sx={{
          justifyContent: {
            xl: "normal",
            md: "normal",
            lg: "normal",
            sm: "start",
            xs: "start",
          },
        }}
      >
        <ToggleButtonGroup
          size="small"
          exclusive
          value={activeValue}
          onChange={onChange}
          sx={{
            ...styles.toggleBtn,
            backgroundColor: isActive ? "#F8F8FF" : "#fff",
          }}
        >
          {toggleOptions.map((option: any) => (
            <ToggleButton key={option.value} value={option.value}>
              {option.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>

        <Button
          variant="contained"
          sx={styles.downloadBtn}
          onClick={onDownload}
          disabled={disabled}
        >
          <CloudDownloadIcon />
        </Button>

        <Button
          variant="contained"
          sx={styles.downloadBtn}
          onClick={excelOption ? serverCSVDownload : downloadAsCSV}
          // disabled={excelOption}
        >
          <DescriptionIcon />
        </Button>
        {onClose && (
          <Button variant="contained" sx={styles.downloadBtn} onClick={onClose}>
            <CloseIcon />
          </Button>
        )}
      </Box>
      <CustomDatePicker
        name={name}
        excelOption={excelOption}
        openDatePicker={openDatePicker}
        openCSVWindow={openCSVWindow}
        setOpenCSVWindow={setOpenCSVWindow}
        setOpenDatePicker={setOpenDatePicker}
        setMonth={setMonth}
        activeValue={activeValue}
      />
    </div>
  );
};

export default actionGroup;
